import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sidebarLeft', 'sidebarRight']

  get mainContainer() {
    return document.querySelector('.show-cards-container')
  }

  fixToTop() {
    const sidebarReachedTheTopY = 158

    if (this.shouldFixTheSidebar()) {
      if (window.scrollY > sidebarReachedTheTopY) {
        this.sidebarLeftTarget.classList.add('fixed-sidebar')
        this.sidebarRightTarget.classList.add('fixed-sidebar')
        this.mainContainer.classList.add('relative-show-cards-container')
      } else {
        this.sidebarLeftTarget.classList.remove('fixed-sidebar')
        this.sidebarRightTarget.classList.remove('fixed-sidebar')
        this.mainContainer.classList.remove('relative-show-cards-container')
      }
    }
  }

  shouldFixTheSidebar() {
    return this.mainContainer.offsetHeight > this.sidebarLeftTarget.offsetHeight
  }
}
